// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4825f4cd","528":"8638ed62","547":"e77863a2","625":"0afedb3e"}[chunkId] + ".chunk.js";
};